import type { Destination, Season } from '../types/content';

export function programmePath(slug: string) {
  return `/programmes/${slug}`;
}

export function destinationPath(destination: Destination, season?: Season) {
  const chosen: Season = season ?? (destination.yearRound ? 'year-round' : 'seasonal');
  const valid = chosen === 'year-round' && !destination.yearRound ? 'seasonal' : chosen;
  return `/destinations/${valid}/${destination.slug}`;
}
